import axios from "./index";

// 示例
const noticeTopQueryApi = (data = {}, config = {}) =>
  axios.post("/v1/app/version/last/view", data, config);

export default {
  noticeTopQueryApi
};



// WEBPACK FOOTER //
// ./src/api/api.js